import type { FC, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { SplashScreen } from "src/components/splash-screen";
import { useOnboardingState } from "src/hooks/use-onboarding-state";

interface OnboardingGuardProps {
  children: ReactNode;
}

export const OnboardingGuard: FC<OnboardingGuardProps> = ({ children }) => {
  const router = useRouter();
  const location = useLocation();
  const state = useOnboardingState();

  if (state.status === "loading") {
    return <SplashScreen />;
  }

  // AuthGuard above us handles unauthenticated/unverified — but if the hook
  // returns those states anyway, don't redirect-loop; just pass through and let
  // AuthGuard deal with it on its next cycle.
  if (state.status === "unauthenticated" || state.status === "unverified") {
    return <>{children}</>;
  }

  if (state.status === "no_pro_group") {
    router.replace(paths.getStarted.account);
    return <SplashScreen />;
  }

  if (state.status === "unpaid") {
    router.replace(paths.getStarted.payment);
    return <SplashScreen />;
  }

  if (state.status === "paid_unboarded") {
    if (state.selfServe) {
      if (location.pathname !== paths.dashboard.upgrade) {
        router.replace(paths.dashboard.upgrade);
        return <SplashScreen />;
      }
    } else {
      router.replace(paths.getStarted.onboarding);
      return <SplashScreen />;
    }
  }

  // onboarded (or self-serve already on /upgrade) — allow through
  return <>{children}</>;
};
